import Swiper, { EffectFade, Autoplay, Pagination } from 'swiper';



export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    const swiper = new Swiper('.swiper', {
      effect: 'fade',
      speed: 1000,
      autoplayDisableOnInteraction: false,
      autoplay: {
        delay: 5000,
      },
      modules: [Pagination, EffectFade, Autoplay],
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    });

    var abbreviations = document.querySelector('.abbreviations')
    abbreviations.addEventListener('click', function(){
      abbreviations.classList.toggle('open')
    });

    console.log(swiper);
    console.log("Boggle");
    document.querySelectorAll('.lightbox-close').forEach((x) => x.addEventListener('click', () => document.querySelectorAll('.lightbox').forEach((y) => y.style.display='none') ));
    document.querySelectorAll('.sub-banner-link').forEach((x) => x.addEventListener('click', () => document.querySelectorAll('.lightbox').forEach(function (y) { 
      if(y.dataset.ref == x.dataset.ref){
        y.style.display = 'flex';
      }
    })));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js